"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var PropTypes = __importStar(require("prop-types"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var getTextChildren_1 = __importDefault(require("../assets/getTextChildren"));

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Text_styles_1 = require("./Text.styles");

var TAG_BY_MODE = {
  h0: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  base: 'p',
  control: 'span',
  label: 'label',
  small: 'small',
  extra_small: 'small'
};

var Text =
/** @class */
function (_super) {
  __extends(Text, _super);

  function Text() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Text.prototype, "tagName", {
    get: function get() {
      return TAG_BY_MODE[this.props.mode || 'base'] || TAG_BY_MODE.base;
    },
    enumerable: false,
    configurable: true
  });

  Text.prototype.getChildContext = function () {
    return {
      parent: 'Text'
    };
  };

  Text.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        _c = _b.mode,
        mode = _c === void 0 ? 'base' : _c,
        primary = _b.primary,
        success = _b.success,
        error = _b.error,
        notify = _b.notify,
        contrast = _b.contrast,
        secondary = _b.secondary,
        block = _b.block,
        inline = _b.inline,
        bold = _b.bold,
        nowrap = _b.nowrap,
        responsive = _b.responsive,
        labelFor = _b.labelFor;
    var className = classnames_1.default(classes.base, [classes[mode]], (_a = {}, _a[classes.mobile] = responsive === 'mobile', _a[classes.auto] = responsive === 'auto', _a[classes.success] = success, _a[classes.primary] = primary, _a[classes.secondary] = secondary, _a[classes.error] = error, _a[classes.notify] = notify, _a[classes.contrast] = contrast, _a[classes.block] = block, _a[classes.inline] = inline, _a[classes.bold] = bold, _a[classes.nowrap] = nowrap, _a));
    var value = getTextChildren_1.default(this.props);
    var tagName = this.tagName;
    var mixProps = {};

    if (tagName === 'label') {
      mixProps.htmlFor = labelFor;
    }

    return react_1.default.createElement(tagName, __assign(__assign(__assign({}, baseProps_1.default(this.props)), mixProps), {
      className: className
    }), value);
  };

  Text.childContextTypes = {
    parent: PropTypes.string
  };
  Text = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(Text_styles_1.styles)], Text);
  return Text;
}(react_1.default.PureComponent);

exports.default = Text;